import Vue from 'vue';
import { authModule } from '@/store';
import { hasAuthority } from '@/utils/';

Vue.directive('has-authority', {
  bind(el, binding) {
    const authorities = authModule.permissions;
    const allowed = authorities.length ? hasAuthority(authorities || [], binding.value) : false;
    el.style.setProperty('display', allowed ? '' : 'none');
  },
});
